import React, { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
  CardActionArea,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Chip,
  Stack
} from '@mui/material';
import {
  Inventory as InventoryIcon,
  ShoppingCart as OrdersIcon,
  Category as CategoryIcon,
  Settings as SettingsIcon,
  Straighten as SizeIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase/config';

function AdminDashboard() {
  const navigate = useNavigate();

  const adminMenuItems = [
    {
      title: 'Ürün Yönetimi',
      description: 'Ürün ekle, düzenle ve sil',
      icon: <InventoryIcon sx={{ fontSize: 40 }} />,
      path: '/admin/products',
      color: '#4CAF50'
    },
    {
      title: 'Sipariş Yönetimi',
      description: 'Siparişleri görüntüle ve yönet',
      icon: <OrdersIcon sx={{ fontSize: 40 }} />,
      path: '/admin/orders',
      color: '#2196F3'
    },
    {
      title: 'Kategori Yönetimi',
      description: 'Kategorileri düzenle',
      icon: <CategoryIcon sx={{ fontSize: 40 }} />,
      path: '/admin/categories',
      color: '#FF9800'
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4, mt: { xs: '56px', sm: '64px' } }}>
      <Paper elevation={0} sx={{ p: 3, bgcolor: '#f8f8f8', borderRadius: 2 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Admin Paneli
        </Typography>
        
        <Grid container spacing={3} sx={{ mt: 2 }}>
          {adminMenuItems.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card 
                sx={{ 
                  height: '100%',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)'
                  }
                }}
              >
                <CardActionArea 
                  onClick={() => navigate(item.path)}
                  sx={{ height: '100%' }}
                >
                  <CardContent>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center'
                      }}
                    >
                      <Box
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          bgcolor: `${item.color}15`,
                          color: item.color,
                          mb: 2
                        }}
                      >
                        {item.icon}
                      </Box>
                      <Typography variant="h6" component="h2" gutterBottom>
                        {item.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {item.description}
                      </Typography>
                    </Box>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Container>
  );
}

export default AdminDashboard; 